// src/api/yearApi.js
import api from "./api";

export const fetchYears = async () => {
  const response = await api.get("api/years/");
  return response.data;
};